import { render, staticRenderFns } from "./HandleStoricoPOD.vue?vue&type=template&id=4c940c32"
import script from "./HandleStoricoPOD.vue?vue&type=script&lang=js"
export * from "./HandleStoricoPOD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports